module.exports = __webpack_public_path__ + "img/profile-pic.8213a8bb.png";